// extracted by mini-css-extract-plugin
export var subtitle = "_d6-2";
export var title = "_d6-0";
export var titleNoWrap = "_d6-1";